// Generated by scripts/convert_khs_small_architecture_to_ys.py.
// Do not hand-edit: rerun the conversion script after changing the source manifest.
export const KHS_SMALL_ARCHITECTURE_PRESET_DATA = [
    ["khs-gyeongbokgung-001", "경복궁 자경전 십장생 굴뚝", "경복궁", 5.0, "🧱"],
    ["khs-gyeongbokgung-002", "경복궁 강녕전 일원 부속건물 어정", "경복궁", 3.0, "⛲"],
    ["khs-gyeongbokgung-003", "경복궁 건청궁 건청궁행각", "경복궁", 7.0, "🏯"],
    ["khs-gyeongbokgung-004", "경복궁 건청궁 곤녕합", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-005", "경복궁 건청궁 복수당", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-006", "경복궁 건청궁 장안당", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-007", "경복궁 건청궁 초양문", "경복궁", 6.0, "🚪"],
    ["khs-gyeongbokgung-008", "경복궁 건청궁 필성문", "경복궁", 6.0, "🚪"],
    ["khs-gyeongbokgung-009", "경복궁 건춘문군사방", "경복궁", 6.0, "🚪"],
    ["khs-gyeongbokgung-010", "경복궁 국별장직소 숙설소", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-011", "경복궁 궐내각사 의약청", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-012", "경복궁 동십자각 남소부장청", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-013", "경복궁 동십자각 동소부장청", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-014", "경복궁 동십자각 별군직청", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-015", "경복궁 동십자각 상의원", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-016", "경복궁 동십자각 오위도총부", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-017", "경복궁 만화당만경전 건기당", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-018", "경복궁 만화당만경전 건복합", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-019", "경복궁 만화당만경전 만경전", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-020", "경복궁 만화당만경전 만화당", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-021", "경복궁 만화당만경전 요광당", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-022", "경복궁 만화당만경전 진전생물방", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-023", "경복궁 만화당만경전 진전소주방", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-024", "경복궁 만화당만경전 통화당", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-025", "경복궁 선원전 경안당", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-026", "경복궁 선원전 내재실", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-027", "경복궁 선원전 동진설청", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-028", "경복궁 선원전 배위청", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-029", "경복궁 선원전 서진설청", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-030", "경복궁 선원전 선원전", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-031", "경복궁 선원전 숙경재", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-032", "경복궁 소주방 내소주방", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-033", "경복궁 소주방 복회당(생물방)", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-034", "경복궁 소주방 외소주방", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-035", "경복궁 신무문", "경복궁", 6.0, "🚪"],
    ["khs-gyeongbokgung-036", "경복궁 신무문 군사방", "경복궁", 6.0, "🚪"],
    ["khs-gyeongbokgung-037", "경복궁 신무문 수문장청", "경복궁", 6.0, "🚪"],
    ["khs-gyeongbokgung-038", "경복궁 영추문 훈국군영직소", "경복궁", 6.0, "🚪"],
    ["khs-gyeongbokgung-039", "경복궁 영추문수문장청", "경복궁", 6.0, "🚪"],
    ["khs-gyeongbokgung-040", "경복궁 집옥재 가회정", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-041", "경복궁 집옥재 건선문", "경복궁", 6.0, "🚪"],
    ["khs-gyeongbokgung-042", "경복궁 집옥재 광림문", "경복궁", 6.0, "🚪"],
    ["khs-gyeongbokgung-043", "경복궁 집옥재 신무문행각", "경복궁", 7.0, "🚪"],
    ["khs-gyeongbokgung-044", "경복궁 함화당집경당 영훈당", "경복궁", 8.0, "🏯"],
    ["khs-gyeongbokgung-045", "경복궁 향원정 열상진원샘", "경복궁", 3.0, "⛲"],
    ["khs-gyeongbokgung-046", "경복궁 향원정 취향교", "경복궁", 4.0, "🌉"],
    ["khs-gyeongbokgung-047", "경복궁 흥례문 영제교어구", "경복궁", 4.0, "🌉"],
    ["khs-deoksugung-001", "덕수궁 광명문", "덕수궁", 6.0, "🚪"],
    ["khs-deoksugung-002", "덕수궁 금천교", "덕수궁", 4.0, "🌉"],
    ["khs-deoksugung-003", "덕수궁 담장", "덕수궁", 2.5, "🧱"],
    ["khs-deoksugung-004", "덕수궁 대한문", "덕수궁", 6.0, "🚪"],
    ["khs-deoksugung-005", "덕수궁 덕홍전", "덕수궁", 8.0, "🏯"],
    ["khs-deoksugung-006", "덕수궁 돈덕전", "덕수궁", 8.0, "🏯"],
    ["khs-deoksugung-007", "덕수궁 분수대", "덕수궁", 3.0, "⛲"],
    ["khs-deoksugung-008", "덕수궁 석류문", "덕수궁", 6.0, "🚪"],
    ["khs-deoksugung-009", "덕수궁 석어당", "덕수궁", 8.0, "🏯"],
    ["khs-deoksugung-010", "덕수궁 석조전", "덕수궁", 14.0, "🏯"],
    ["khs-deoksugung-011", "덕수궁 석조전 서관", "덕수궁", 14.0, "🏯"],
    ["khs-deoksugung-012", "덕수궁 수강문", "덕수궁", 6.0, "🚪"],
    ["khs-deoksugung-013", "덕수궁 용덕문", "덕수궁", 6.0, "🚪"],
    ["khs-deoksugung-014", "덕수궁 월곡문", "덕수궁", 6.0, "🚪"],
    ["khs-deoksugung-015", "덕수궁 유현문", "덕수궁", 6.0, "🚪"],
    ["khs-deoksugung-016", "덕수궁 융안문", "덕수궁", 6.0, "🚪"],
    ["khs-deoksugung-017", "덕수궁 융안문 행각", "덕수궁", 7.0, "🚪"],
    ["khs-deoksugung-018", "덕수궁 준명당", "덕수궁", 8.0, "🏯"],
    ["khs-deoksugung-019", "덕수궁 즉조당", "덕수궁", 8.0, "🏯"],
    ["khs-deoksugung-020", "덕수궁 창신문", "덕수궁", 6.0, "🚪"],
    ["khs-deoksugung-021", "덕수궁 치중문", "덕수궁", 6.0, "🚪"],
    ["khs-deoksugung-022", "덕수궁 평성문", "덕수궁", 6.0, "🚪"],
    ["khs-deoksugung-023", "덕수궁 함녕전 행각", "덕수궁", 7.0, "🏯"],
    ["khs-changgyeonggung-001", "창경궁 옥천교", "창경궁", 8.0, "🌉"],
    ["khs-changgyeonggung-002", "창경궁 홍화문", "창경궁", 6.0, "🚪"],
    ["khs-changgyeonggung-003", "창경궁 명정전 남월랑", "창경궁", 7.0, "🏯"],
    ["khs-changgyeonggung-004", "창경궁 명정전 복도각", "창경궁", 8.0, "🏯"],
    ["khs-changgyeonggung-005", "창경궁 명정전 북월랑", "창경궁", 7.0, "🏯"],
    ["khs-changgyeonggung-006", "창경궁 빈양문", "창경궁", 6.0, "🚪"],
    ["khs-changgyeonggung-007", "창경궁 선인문", "창경궁", 6.0, "🚪"],
    ["khs-changgyeonggung-008", "창경궁 선인문 후면 석교", "창경궁", 4.0, "🌉"],
    ["khs-changgyeonggung-009", "창경궁 숭문당", "창경궁", 6.0, "🚪"],
    ["khs-changgyeonggung-010", "창경궁 함양문", "창경궁", 6.0, "🚪"],
    ["khs-changdeokgung-001", "창덕궁 금천교", "창덕궁", 4.0, "🌉"],
    ["khs-changdeokgung-002", "창덕궁 궐내각사 검서청", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-003", "창덕궁 궐내각사 검서청부속채", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-004", "창덕궁 궐내각사 경추문", "창덕궁", 6.0, "🚪"],
    ["khs-changdeokgung-005", "창덕궁 궐내각사 규장각", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-006", "창덕궁 궐내각사 규장각문간채", "창덕궁", 7.0, "🚪"],
    ["khs-changdeokgung-007", "창덕궁 궐내각사 내각", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-008", "창덕궁 궐내각사 만우문", "창덕궁", 6.0, "🚪"],
    ["khs-changdeokgung-009", "창덕궁 궐내각사 무명1", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-010", "창덕궁 궐내각사 무명2", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-011", "창덕궁 궐내각사 무명3", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-012", "창덕궁 궐내각사 봉모당", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-013", "창덕궁 궐내각사 약방", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-014", "창덕궁 궐내각사 약방 동행각", "창덕궁", 7.0, "🏯"],
    ["khs-changdeokgung-015", "창덕궁 궐내각사 영의사", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-016", "창덕궁 궐내각사 옥당", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-017", "창덕궁 궐내각사 옥당 남행각 등영루", "창덕궁", 7.0, "🏯"],
    ["khs-changdeokgung-018", "창덕궁 궐내각사 운한문", "창덕궁", 6.0, "🚪"],
    ["khs-changdeokgung-019", "창덕궁 궐내각사 정청부속채", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-020", "창덕궁 궐내각사 책고1", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-021", "창덕궁 궐내각사 책고2", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-022", "창덕궁 낙선재 무명1", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-023", "창덕궁 낙선재 무명2", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-024", "창덕궁 낙선재 사각당", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-025", "창덕궁 낙선재 상량정 행각", "창덕궁", 7.0, "🏯"],
    ["khs-changdeokgung-026", "창덕궁 낙선재 석복헌 행각", "창덕궁", 7.0, "🏯"],
    ["khs-changdeokgung-027", "창덕궁 낙선재 수강재", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-028", "창덕궁 낙선재 수강재 행각", "창덕궁", 7.0, "🏯"],
    ["khs-changdeokgung-029", "창덕궁 낙선재 취운정", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-030", "창덕궁 낙선재 한정당", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-031", "창덕궁 돈화문 금호문", "창덕궁", 6.0, "🚪"],
    ["khs-changdeokgung-032", "창덕궁 돈화문 단봉문", "창덕궁", 6.0, "🚪"],
    ["khs-changdeokgung-033", "창덕궁 신선원전 능허정", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-034", "창덕궁 신선원전 동진설청", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-035", "창덕궁 신선원전 문간채", "창덕궁", 7.0, "🚪"],
    ["khs-changdeokgung-036", "창덕궁 신선원전 북진설청", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-037", "창덕궁 신선원전 서진설청", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-038", "창덕궁 신선원전 수복방", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-039", "창덕궁 신선원전 외삼문", "창덕궁", 6.0, "🚪"],
    ["khs-changdeokgung-040", "창덕궁 신선원전 의효전", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-041", "창덕궁 신선원전 의효전 남행각", "창덕궁", 7.0, "🏯"],
    ["khs-changdeokgung-042", "창덕궁 신선원전 의효전 북행각", "창덕궁", 7.0, "🏯"],
    ["khs-changdeokgung-043", "창덕궁 신선원전 재실", "창덕궁", 8.0, "🏯"],
    ["khs-changdeokgung-044", "창덕궁 신선원전 재실사주문", "창덕궁", 6.0, "🚪"],
    ["khs-changdeokgung-045", "창덕궁 신선원전 협문", "창덕궁", 6.0, "🚪"],
    ["khs-changdeokgung-046", "창덕궁 애련지 의두합 금마문", "창덕궁", 6.0, "🚪"],
    ["khs-changdeokgung-047", "창덕궁 애련지 의두합 불로문", "창덕궁", 6.0, "🚪"],
    ["khs-changdeokgung-048", "창덕궁 존덕정 다리", "창덕궁", 4.0, "🌉"],
] as const;
